<template lang="pug">
  WtEntityTable#member-stats-table(
    title="Member Stats Summary"
    :data="_.get(membersResponseObject, 'data', [])"
    :pagination-object="membersResponseObject.pagination"
    :fetch-action="fetchAction"
    default-sort-field="username"
    empty-message="No members have been added yet"
  )
    BTableColumn(field="username" label="Username" sortable v-slot="column")
      | {{ column.row.username }}
    BTableColumn(field="walk_users.user_stepsavg" label="Step Average" sortable v-slot="column")
      | {{ _.get(column.row, "memberData.stepAverage", "") }}
    BTableColumn(field="walk_users.user_stepstotal" label="Step Total" sortable v-slot="column")
      | {{ _.get(column.row, "memberData.stepTotal", "") }}
    BTableColumn(field="walk_users.user_numentries" label="Entries" sortable v-slot="column")
      | {{ _.get(column.row, "memberData.numberOfEntries", "") }}
</template>

<script>
import tablePropsMixin from "@/mixins/tablePropsMixin";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";

export default {
  name: "MemberStatsTable",

  components: { WtEntityTable },

  mixins: [tablePropsMixin],

  props: {
    membersResponseObject: {
      type: Object,
      required: true
    },

    fetchAction: {
      type: Function,
      default: () => {}
    }
  }
};
</script>

<style lang="sass" scoped></style>
